/** @format */

import * as React from "react";
import {
  Flex,
  Image,
  Text,
  useMediaQuery,
  AspectRatio
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import theme from "@src/style/theme";
import colors from "@src/style/colors";
import dompurify from "dompurify";

export const Feature_KR: React.FC = () => {
  const [isSmall] = useMediaQuery([`(max-width: ${theme.breakpoints.md})`]);
  const sanitizer = dompurify.sanitize;

  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };

  return (
    <>
      {commonInfo.feature.map((item, index) => (
        <Flex
          key={index}
          direction={"row"}
          justifyContent={"center"}
          alignItems={"stretch"}
          bgColor={index % 2 == 0 ? colors.blue : colors.white}
          width={"100%"}
          paddingX={basePaddingX}
          paddingY={basePaddingY}>
          {isSmall ? (
            <>
              <Flex
                maxWidth={theme.breakpoints.mx}
                width={"100%"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}>
                <Text
                  alignSelf={"flex-start"}
                  wordBreak={"keep-all"}
                  textAlign={"start"}
                  fontSize={{
                    base: "24px",
                    sm: "32px"
                  }}
                  fontWeight={700}
                  color={index % 2 == 0 ? colors.white : colors.black}
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(item.title)
                  }}
                />
                <Image
                  mt={{ base: "18px", sm: "22px" }}
                  src={item.image}
                  objectFit={"cover"}
                  borderRadius={24}
                />
                <Text
                  fontSize={{
                    base: "14px",
                    sm: "16px"
                  }}
                  mt={{
                    base: "18px",
                    sm: "22px"
                  }}
                  wordBreak={"keep-all"}
                  fontWeight={400}
                  color={index % 2 == 0 ? colors.white : colors.black}
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(item.description)
                  }}
                />
              </Flex>
            </>
          ) : (
            <>
              <Flex
                maxWidth={theme.breakpoints.mx}
                width={"100%"}
                flexDirection={index % 2 == 0 ? "row" : "row-reverse"}
                justifyContent={"space-between"}
                alignItems={"start"}>
                <Flex
                  flexDirection={"column"}
                  justifyContent={"flex-start"}
                  alignItems={"stretch"}
                  textAlign={"start"}
                  width={"50%"}>
                  <Text
                    fontSize={{
                      md: "42px",
                      lg: "52px",
                      xl: "64px"
                    }}
                    wordBreak={"keep-all"}
                    fontWeight={700}
                    color={index % 2 == 0 ? colors.white : colors.black}
                    dangerouslySetInnerHTML={{
                      __html: sanitizer(item.title)
                    }}
                  />
                  <Text
                    fontSize={{
                      md: "18px",
                      lg: "18px",
                      xl: "24px"
                    }}
                    wordBreak={"keep-all"}
                    mt={{
                      base: "30px",
                      sm: "40px",
                      md: "30px",
                      lg: "30px",
                      xl: "60px"
                    }}
                    fontWeight={400}
                    color={index % 2 == 0 ? colors.white : colors.black}
                    dangerouslySetInnerHTML={{
                      __html: sanitizer(item.description)
                    }}
                  />
                </Flex>
                <AspectRatio width={"40%"} ratio={4 / 3}>
                  <Image
                    src={item.image}
                    objectFit={"cover"}
                    borderRadius={24}
                  />
                </AspectRatio>
              </Flex>
            </>
          )}
        </Flex>
      ))}
    </>
  );
};

export default Feature_KR;
